
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsProvider";
import "./StaticPage.css";

function CareersPage() {
    const { settings } = useSettings();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="main-content">
            <Helmet>
                <title>Careers - {settings?.site_name || "Play Store"}</title>
                <meta name="description" content="Join our team and help shape the future of app distribution" />
            </Helmet>

            <div className="static-page-container">
                <div className="page-header">
                    <h1>Join Our Team</h1>
                    <p className="page-subtitle">Help us build the future of app distribution</p>
                </div>

                <div className="page-content">
                    <section className="content-section">
                        <h2>🌟 Why Work With Us?</h2>
                        <div className="feature-grid">
                            <div className="feature-card">
                                <div className="feature-icon">💼</div>
                                <h3>Great Culture</h3>
                                <p>Collaborative and innovative work environment</p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">🚀</div>
                                <h3>Growth</h3>
                                <p>Opportunities for professional development</p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">🏖️</div>
                                <h3>Work-Life Balance</h3>
                                <p>Flexible hours and remote options</p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">💰</div>
                                <h3>Competitive Pay</h3>
                                <p>Attractive salary and benefits package</p>
                            </div>
                        </div>
                    </section>

                    <section className="content-section">
                        <h2>📋 Open Positions</h2>
                        <div style={{
                            background: '#f8f9fa',
                            padding: '40px',
                            borderRadius: '12px',
                            textAlign: 'center',
                            border: '2px dashed #dadce0'
                        }}>
                            <div style={{ fontSize: '64px', marginBottom: '20px' }}>💼</div>
                            <h3 style={{ fontSize: '24px', fontWeight: '600', color: '#1a1a1a', marginBottom: '12px' }}>
                                No Open Positions at the Moment
                            </h3>
                            <p style={{ fontSize: '16px', color: '#5f6368', lineHeight: '1.6', maxWidth: '600px', margin: '0 auto' }}>
                                We don't have any open positions right now, but we're always looking for talented individuals. 
                                Feel free to send us your resume and we'll keep it on file for future opportunities.
                            </p>
                        </div>
                    </section>

                    <section className="content-section">
                        <h2>📧 How to Apply</h2>
                        <p>Interested in joining our team? Send your resume and portfolio to:</p>
                        <div className="contact-info">
                            <p><strong>Email:</strong> careers@{settings?.site_name?.toLowerCase() || "example"}.com</p>
                            <p><strong>Subject:</strong> [Position Name] - Your Name</p>
                        </div>
                    </section>

                    <section className="content-section">
                        <h2>🎯 What We Look For</h2>
                        <ul className="requirements-list">
                            <li>Passion for technology and innovation</li>
                            <li>Strong problem-solving skills</li>
                            <li>Team player with excellent communication</li>
                            <li>Self-motivated and proactive</li>
                            <li>Commitment to quality and excellence</li>
                        </ul>
                    </section>
                </div>
            </div>
        </main>
    );
}

export default CareersPage;
